/** @format */

export const utilityGenerateNickname = (name: string = "", lastName: string = ""): string =>
  name && lastName
    ? `${name.split(" ").join("")}.${lastName.split(" ").join("")}`.toLowerCase()
    : "";
